const wxConsultationRoutes = Array.from({ length: 16 }, (_, i) => ({
  path: `consultation/wx/index${i + 1}`,
  name: `consultationWxIndex${i + 1}`,
  component: () => import(`@/views/health/consultation/wx/index${i + 1}.vue`),
}));


export default {
  path: "/health",
  component: { render: (c) => c("router-view") },
  children: [
    ...wxConsultationRoutes,
  ],
};
